"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLEAN_PROPERTYINSPECTOR = exports.BEFORE_CLOSE_WINDOW = exports.SAVE_FILE_CONTENT = exports.FLOW_ROLLBACK = exports.FLOW_FILE_CONTENT = exports.PROCESS_PROPERTIES_LOAD = exports.PROCESS_STEPS_LOAD = exports.FLOW_DETAIL = exports.OPEN = void 0;
exports.OPEN = 'FLOW_MANAGER.OPEN';
exports.FLOW_DETAIL = 'FLOW_MANAGER.FLOW_DETAIL';
exports.PROCESS_STEPS_LOAD = 'FLOW_MANAGER.PROCESS_STEPS_LOAD';
exports.PROCESS_PROPERTIES_LOAD = 'FLOW_MANAGER.PROCESS_PROPERTIES_LOAD';
exports.FLOW_FILE_CONTENT = 'FLOW_MANAGER.FLOW_FILE_CONTENT';
exports.FLOW_ROLLBACK = 'FLOW_MANAGER.FLOW_ROLLBACK';
exports.SAVE_FILE_CONTENT = 'FLOW_MANAGER.SAVE_FILE_CONTENT';
exports.BEFORE_CLOSE_WINDOW = 'DOCKER.BEFORE_CLOSE_WINDOW';
exports.CLEAN_PROPERTYINSPECTOR = 'FLOW_MANAGER.CLEAN_PROPERTYINSPECTOR';
//# sourceMappingURL=actionTypes.js.map